import { Autocomplete, TextField, Box, Typography, Chip } from '@mui/material';

// FEAT-005 Phase 5 — owner 필드 ContactSelector.
// 사용자 결정: freeSolo 미허용 — contacts.yaml 멤버만 엄격하게 선택.
//
// Props:
//   value     : 현재 owner 의 email (PK) 또는 이름 (legacy)
//   onChange  : (newEmail | null) => void  — email PK 로 저장
//   members   : flat members list (api/featureMap.js getContacts().membersFlat)
//   label     : TextField label (기본 "담당자")
//   size      : 'small' | 'medium'
//   required  : boolean
export default function ContactSelector({
  value,
  onChange,
  members,
  label = '담당자',
  size = 'small',
  required = false,
}) {
  // value 가 email PK 인지 이름 (legacy) 인지 판별 — @ 포함 시 email
  const selected = members.find((m) => {
    if (!value) return false;
    if (value.includes('@')) return m.email === value;
    return m.name === value;
  }) || null;

  return (
    <Autocomplete
      size={size}
      options={members}
      value={selected}
      onChange={(_, v) => onChange(v?.email || null)}
      getOptionLabel={(m) => m ? `${m.name} (${m.email})` : ''}
      isOptionEqualToValue={(a, b) => a.email === b.email}
      filterOptions={(opts, { inputValue }) => {
        const q = (inputValue || '').toLowerCase();
        if (!q) return opts;
        return opts.filter((m) =>
          `${m.name} ${m.email} ${m.teamName || ''} ${m.role || ''}`.toLowerCase().includes(q),
        );
      }}
      renderOption={(props, m) => (
        <Box component="li" {...props} key={m.email} sx={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start !important', gap: 0.5 }}>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, width: '100%' }}>
            <Typography variant="body2" sx={{ fontWeight: 600 }}>{m.name}</Typography>
            {m.role && <Chip label={m.role} size="small" sx={{ height: 16, fontSize: 10 }} />}
            {m.grade && <Typography variant="caption" sx={{ color: 'text.secondary' }}>{m.grade}</Typography>}
          </Box>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, width: '100%' }}>
            <Typography variant="caption" sx={{ fontFamily: 'JetBrains Mono, monospace', color: 'text.secondary' }}>
              {m.email}
            </Typography>
            {m.teamName && (
              <Typography variant="caption" sx={{ color: 'text.disabled' }}>· {m.teamName}</Typography>
            )}
          </Box>
        </Box>
      )}
      renderInput={(params) => (
        <TextField
          {...params}
          label={label}
          placeholder="검색: 이름 / email / 팀..."
          required={required}
          helperText={selected ? `${selected.teamName || selected.orgName || ''}${selected.role ? ' · ' + selected.role : ''}` : '연구소 / SW개발본부 멤버 중 선택'}
        />
      )}
    />
  );
}
